<script lang="ts">
    import favOutline from "../assets/fav-outline.svg?raw";
</script>

<button
    class="soundcard-button blue-50a no-tooltip-underline"
    data-tooltip="Coming Soon!"
    data-placement="left"
>
    {@html favOutline}
</button>
